import { gql } from 'graphql-tag'
import queryPageFields from '#layers/core/data-layer/pages/page/query-page-fields.js'
import { fragmentModuleChapter } from '#layers/core/data-layer/modules/fragments'

export default gql`
  ${fragmentModuleChapter}
  query($slug: String! = "", $sysId: String! = "", $locale: String!, $preview: Boolean!) {
    page: pageInfrastructureCollection(limit: 1, where: { OR: [{ sys: { id: $sysId }}, { slug: $slug }]}, locale: $locale, preview: $preview) {
      items {
        ${queryPageFields}
        defaultLocaleFallbackEnabled
        introText {
          json
        }
        chaptersCollection(limit: 20) {
          items {
            ...ModuleChapterFragment
          }
        }
      }
    }
  }
`
